//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "FFM",
  data() {
    return {
      active: false,
      form: {
        h: '',
        w: '',
      },
      hasScore: false,
      disabled: false,
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
    numChange() {
      this.active = !this.active;
    },
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      console.log('form', self.active)
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            if (form[key] == "---") {
              flag = false;
            } else {
              form[key] = Number(form[key]);
            }
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "--";
      } else {
        let genderVal = self.active ? [6680,216] : [8780,244];
        let height = form.h/100
        let bmi = form.w / (height*height);
        let numerator = 9270*form.w;
        let denominator = genderVal[0] + genderVal[1] * bmi;
        let result = (numerator/denominator);
        self.hasScore = true;
        return String(result.toFixed(2));
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/FFM.vue